import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HeaderConfigService {
    private headerVisibilitySubject: BehaviorSubject<boolean>;

    constructor() {
        this.headerVisibilitySubject = new BehaviorSubject<boolean>(true);
    }

    public setVisibility(visibility: boolean): void {
        this.headerVisibilitySubject.next(visibility);
    }

    public getVisibility$(): Observable<boolean> {
        return this.headerVisibilitySubject.asObservable();
    }

    public getVisibilityValue(): boolean {
        return this.headerVisibilitySubject.value;
    }
}
